import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProductsAll } from '../../api/products';
import { Spinner } from 'react-bootstrap';
import AddProductModal from './AddProductModal';
import EditProductModal from './EditProductModal';

function TaskList() {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ProductData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterUnit, setFilterUnit] = useState('all');
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOrderClick = () => {
    setShowModal(true);
  };

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedProduct(null);
  };

  const handleDeleteClick = (item) => {
    if (window.confirm(`Are you sure you want to delete product "${item.name}"?`)) {
      console.log('Delete product:', item);
      // TODO: Implement delete functionality
      alert('Delete functionality will be implemented with backend integration');
    }
  };

  function getProducts() {
    setLoading(true);
    getProductsAll((result) => {
      setLoading(false);
      if (result.ok !== 1) {
        console.log(result);
        return;
      }
      setProductData(result.result);
    });
  }

  useEffect(() => {
    getProducts();
  }, []);

  const filteredData = ProductData.filter(item => {
    const matchesSearch = item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.unit?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesUnit = filterUnit === 'all' || 
                       item.unit?.toLowerCase().includes(filterUnit.toLowerCase());
    return matchesSearch && matchesUnit;
  });

  // Get unique units for filter
  const uniqueUnits = [...new Set(ProductData.map(item => item.unit))].filter(Boolean);

  // Calculate statistics
  const totalProducts = ProductData.length;
  const assignedProducts = ProductData.filter(item => item.count_assign && parseInt(item.count_assign) > 0).length;
  const unassignedProducts = totalProducts - assignedProducts;
  const totalAssignments = ProductData.reduce((sum, item) => sum + (parseInt(item.count_assign) || 0), 0);

  const ProductCard = ({ item, index }) => (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0" style={{width: '40px', height: '40px'}}>
              <i className="bi bi-box-seam text-success"></i>
            </div>
            <div className="flex-grow-1 min-w-0">
              <h6 className="mb-1 fw-bold text-truncate">{item.name}</h6>
              <small className="text-muted d-block">
                <i className="bi bi-hash me-1"></i>
                Product #{index + 1}
              </small>
            </div>
          </div>
          <div className="flex-shrink-0">
            <span className="badge bg-primary fs-6">
              {item.unit}
            </span>
          </div>
        </div>

        <div className="row g-2 mb-3">
          <div className="col-12">
            <small className="text-muted d-block">Assigned Traders</small>
            <div className="d-flex align-items-center">
              <i className="bi bi-people me-2 text-muted"></i>
              <small className="fw-medium">
                {item.count_assign || 0} {parseInt(item.count_assign) === 1 ? 'trader' : 'traders'}
              </small>
            </div>
          </div>
        </div>

        <div className="d-flex gap-2">
          <button
            onClick={() => handleEditClick(item)}
            className="btn btn-outline-primary btn-sm flex-fill"
          >
            <i className="bi bi-pencil me-1"></i>
            Edit
          </button>
          <button
            onClick={() => handleDeleteClick(item)}
            className="btn btn-outline-danger btn-sm flex-fill"
          >
            <i className="bi bi-trash me-1"></i>
            Delete
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          {/* Header */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h2 className="mb-1 fw-bold">Product Management</h2>
                <p className="text-muted">Manage products and trader assignments</p>
              </div>
              <button 
                onClick={handleOrderClick}
                className="btn btn-primary"
              >
                <i className="bi bi-plus-circle me-2"></i>
                Add Product
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Total Products</p>
                      <h3 className="mb-0 fw-bold">{totalProducts}</h3>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-box-seam fs-4 text-primary"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Assigned Products</p>
                      <h3 className="mb-0 fw-bold text-success">{assignedProducts}</h3>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-check-circle fs-4 text-success"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Unassigned</p>
                      <h3 className="mb-0 fw-bold text-warning">{unassignedProducts}</h3>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-dash-circle fs-4 text-warning"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted mb-1 small">Total Assignments</p>
                      <h3 className="mb-0 fw-bold text-info">{totalAssignments}</h3>
                    </div>
                    <div className="bg-info bg-opacity-10 p-3 rounded flex-shrink-0">
                      <i className="bi bi-people fs-4 text-info"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filters and Search */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12 col-md-8">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <i className="bi bi-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="Search by product name or unit..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <select
                    className="form-select"
                    value={filterUnit}
                    onChange={(e) => setFilterUnit(e.target.value)}
                  >
                    <option value="all">All Units</option>
                    {uniqueUnits.map((unit, index) => (
                      <option key={index} value={unit}>{unit}</option>
                    ))}
                  </select>
                </div>

                <div className="col-12">
                  <div className="d-flex gap-2 flex-wrap align-items-center">
                    <button
                      onClick={getProducts}
                      disabled={loading}
                      className="btn btn-sm btn-outline-secondary"
                      title="Refresh"
                    >
                      <i className={`bi bi-arrow-clockwise ${loading ? 'spinner-border spinner-border-sm' : ''}`}></i>
                      {loading ? ' Loading...' : ' Refresh'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <i className="bi bi-box-seam fs-1 text-muted"></i>
              <p className="text-muted mt-2">No products found</p>
            </div>
          ) : (
            <>
              {/* Mobile Card View (visible on small and medium screens) */}
              <div className="d-block d-xl-none">
                {filteredData.map((item, index) => (
                  <ProductCard key={item.id || index} item={item} index={index} />
                ))}
              </div>

              {/* Desktop Table View (visible on extra large screens) */}
              <div className="card border-0 shadow-sm d-none d-xl-block">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '60px'}}>#</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '200px'}}>Product Name</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '100px'}}>Unit</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '150px'}}>Assigned Traders</th>
                          <th className="fw-semibold text-uppercase small border-0" style={{minWidth: '120px'}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>
                              <span className="fw-medium">#{index + 1}</span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-box-seam text-success small"></i>
                                </div>
                                <span className="fw-medium text-truncate" style={{maxWidth: '150px'}} title={item.name}>
                                  {item.name}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-primary bg-opacity-10 text-primary">
                                {item.unit}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '32px', height: '32px'}}>
                                  <i className="bi bi-people text-info small"></i>
                                </div>
                                <span className="fw-medium">
                                  {item.count_assign || 0} {parseInt(item.count_assign) === 1 ? 'trader' : 'traders'}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex gap-1">
                                <button 
                                  onClick={() => handleEditClick(item)}
                                  className="btn btn-sm btn-outline-primary" 
                                  title="Edit"
                                >
                                  <i className="bi bi-pencil"></i>
                                </button>
                                <button 
                                  onClick={() => handleDeleteClick(item)}
                                  className="btn btn-sm btn-outline-danger" 
                                  title="Delete"
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Footer */}
          <div className="mt-3 text-center text-muted small">
            Showing {filteredData.length} of {ProductData.length} products
          </div>
        </div>
      </div>

      <AddProductModal 
        show={showModal} 
        handleClose={handleCloseModal} 
      />

      <EditProductModal 
        show={showEditModal} 
        handleClose={handleCloseEditModal} 
        product={selectedProduct}
      />
    </div>
  );
}

export default TaskList;